<script>
import { computed } from "vue";
import ModalComponent from "@/components/ModalComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";

export default {
  name: "ModalConsentPolicyComponent" ,
  components: {
    LoaderComponent,
    ModalComponent
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    fields: {
      type: Object,
      required: true
    },
    submitHandler: {
      type: Function,
      required: true
    },
    loader: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {

    const show = computed({
      get: () => props.show,
      set: (value) => emit('update:show', value),
    });

    return {
      show,
    }
  }
}
</script>

<template>
  <modal-component v-model:show="show" title="СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ." :width-percent="50" :min-width-px="400">
    <template v-slot:body>
      <div class="notify-content">
        <h2>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ.</h2>
        <p>Оставляя на сайте, размещенном по веб-адресу: https://наследство.онлайн , принадлежащем ООО «ФИНЭК-КОНСАЛТ-АУДИТ», ИНН 7825050767, оператор персональных данных рег.№ 78-22-026814 (далее - Администрация Сайта), любые из Ваших данных (которые отнесены к категории персональных в соответствии с ФЗ «О персональных данных» от 27.07.2006 №152-ФЗ), путем заполнения полей любых форм на Сайте, Вы приобретаете статус пользователя Сайта (далее-Пользователь Сайта) и соглашаетесь:</p>
        <ul>
          <li>• политикой конфиденциальности сайта Наследство.Онлайн;</li>
          <li>• политикой по работе с персональными данными ООО «ФИНЭК-КОНСАЛТ-АУДИТ», ИНН 7825050767;</li>
          <li>• подтверждаете, что все указанные в формах регистрации на Сайте данные принадлежат лично Вам, соответствуют действительности, не искажены;</li>
          <li>• подтверждаете и признаете, что внимательно в полном объеме прочитали настоящее Согласие и условия обработки персональных данных, изложенные в политике конфиденциальности и политике по работе с персональными данными (далее – Политики). Текст Согласия условий обработки персональных данных, изложенных в Политиках, Вам понятны и Вы с ними согласны;</li>
          <li>• даете согласие на обработку Администрацией Сайта предоставляемых в составе информации персональных данных в целях заключения между Вами и Сайтом настоящего Соглашения, а также его последующего исполнения;</li>
          <li>• выражает согласие с условиями обработки персональных данных без оговорок и ограничений.</li>
        </ul>
        <p>Согласие Пользователя Сайта на обработку персональных данных является конкретным, информированным и сознательным. Отзыв согласия на обработку персональных данных может быть осуществлен путем направления Пользователем соответствующего распоряжения в простой письменной форме на адрес электронной почты info@finec-audit.ru</p>
        <p>Администрация Сайта не несет ответственности за использование (как правомерное, так и неправомерное) третьими лицами Информации, размещенной Пользователем Сайта на Сайте, включая её воспроизведение и распространение, осуществленные всеми возможными способами. Администрация Сайта в любое время имеет право вносить изменения в Политики и настоящее Согласие.</p>
        <p>При внесении изменений в актуальной редакции Согласия или любой из Политик указывается дата последнего обновления. Новая редакция Согласия или Политик вступает в силу с момента ее размещения. У Пользователя Сайта в случае изменений будет запрошено повторное подтверждения согласия при очередном посещении Сайта при авторизации.</p>
        <form @submit="submitHandler">
          <div class="form-group">
            <div>
              <input type="checkbox" v-model="fields.confirmPolicy1.value" />
              <label>соглашаюсь с <a href="/policy#pol_pers" target="_blank">Политикой конфиденциальности сайта Наследство.Онлайн</a></label>
            </div>
            <p class="error" v-if="fields.confirmPolicy1.error !== ''">{{ fields.confirmPolicy1.error }}</p>
          </div>
          <div class="form-group">
            <div>
              <input type="checkbox" v-model="fields.confirmPolicy2.value" />
              <label>соглашаюсь с <a href="/policy" target="_blank">Политикой по работе с персональными данными</a> ООО «ФИНЭК-КОНСАЛТ-АУДИТ», ИНН 7825050767</label>
            </div>
            <p class="error" v-if="fields.confirmPolicy2.error !== ''">{{ fields.confirmPolicy2.error }}</p>
          </div>
          <div class="form-group form-group-button">
            <button type="submit" class="btn btn-primary" :disabled="!fields.confirmPolicy1.value || !fields.confirmPolicy2.value">ПОДТВЕРЖДАЮ СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</button>
          </div>
        </form>
      </div>
      <loader-component v-if="loader" />
    </template>
  </modal-component>
</template>

<style scoped>

.notify-content {
  text-align: left;
  padding: 0 20px;
}

.notify-content h2 {
  text-align: center;
}

.notify-content p {
  margin: 15px 0;
}

.notify-content ul {
  margin-left: 15px;
}

.notify-content ul>li {
  margin: 5px 0;
  line-height: 15px;
}

.notify-content form input {
  margin-right: 10px;
}

.notify-content form>div input,
.notify-content form>div label {
  margin-bottom: 0;
  display: inline-block;
  vertical-align: middle;
}

.notify-content form .form-group-button {
  text-align: center;
}

.notify-content p {
  line-height: 15px;
}

.notify-content form .form-group-button button {
  background-color: #b7d1df75;
  border: none;
  color: #333333;
}

</style>
